"use client";

import { RefreshCw } from "lucide-react";
import { ErrorScreen } from "@/components/virtualspace/error-screen";

/**
 * Error-boundary body for a server action the live deployment no longer
 * has. Retrying in place re-runs the same outdated code, so the only way
 * forward is a full reload.
 */
export function StaleDeploymentErrorScreen({ immersive = false }: { immersive?: boolean }) {
  return (
    <ErrorScreen
      variant="error"
      icon={RefreshCw}
      immersive={immersive}
      eyebrow="Update available"
      title="This page is out of date."
      description="We updated the app while this page was open, so your last action didn't go through. Reload to pick up the latest version, then try again."
      primaryAction={
        <button
          onClick={() => window.location.reload()}
          className="vs-btn-solid inline-flex items-center gap-2 px-5 py-2.5 text-sm"
        >
          <RefreshCw className="h-4 w-4" />
          Reload page
        </button>
      }
    />
  );
}
